/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Unlock(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
            viewBox='0 0 25 32.5'
        >
            <svg xmlns='http://www.w3.org/2000/svg'>
                <g>
                    <title>unlock</title>
                    <g
                        data-name='Layer 2'
                        id='Layer_2'
                    >
                        <g
                            data-name='Layer 1'
                            fill={iconColor || '#000'}
                            id='Layer_1-2'
                        >
                            <path d='M23.34,28.34a2.51,2.51,0,0,1-2.5,2.5H4.17a2.5,2.5,0,0,1-2.5-2.5V17.5A2.5,2.5,0,0,1,4.17,15H20.83a2.51,2.51,0,0,1,2.5,2.5V28.34Zm-2.5-15h-15v-5a6.67,6.67,0,0,1,13.34,0v.83h1.67V8.34a8.34,8.34,0,1,0-16.67,0v5A4.17,4.17,0,0,0,0,17.5V28.34A4.17,4.17,0,0,0,4.17,32.5H20.83A4.17,4.17,0,0,0,25,28.34V17.5a4.16,4.16,0,0,0-4.16-4.16Z' />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}